module.exports = __webpack_public_path__ + "img/unavailable-bike.0baddcb5.svg";